import React, { forwardRef, useEffect, useRef, useState } from 'react';
import Cookies from 'js-cookie';
import { requestClassByProtocol } from '../../../services/requests';
import { requestNeverevents } from '../../../services/newNotesRequest';

const avoidPageBreakStyle = {
	breakInside: 'avoid',
	pageBreakInside: 'avoid',
	WebkitColumnBreakInside: 'avoid',
};

const ClassificacaoPDF = forwardRef(({ classificacao, notificacao, onReady }, ref) => {
	const [incidenteLabel, setIncidenteLabel] = useState('');
	const [neverEventLabel, setNeverEventLabel] = useState('');
	const [prazoLabel, setPrazoLabel] = useState('');
	const [isNeverEvents, setIsNeverEvents] = useState(false);
	const onReadyRef = useRef(onReady);

	useEffect(() => {
		onReadyRef.current = onReady;
	}, [onReady]);

	const formatIncidente = (value) => {
		if (!value) return '';
		const noSeparators = value.replace(/[_-]+/g, ' ');
		const lower = noSeparators.toLowerCase();
		return lower.charAt(0).toUpperCase() + lower.slice(1);
	};

	const formatDateBr = (value) => {
		if (!value) return '';
		const onlyDate = value.split('T')[0];
		const parts = onlyDate.split('-');
		if (parts.length !== 3) return value;
		const [year, month, day] = parts;
		return `${day}/${month}/${year}`;
	};

	useEffect(() => {
		let isMounted = true;
		const loadClassificacao = async () => {
			try {
				setIncidenteLabel('');
				setNeverEventLabel('');
				setPrazoLabel('');
				setIsNeverEvents(false);

				let data = classificacao || {};

				const userCookie = Cookies.get('user');
				const hasProtocolo = notificacao?.protocolo;
				if (!classificacao && userCookie && hasProtocolo) {
					const { token } = JSON.parse(userCookie);
					if (token) {
						const apiResult = await requestClassByProtocol(
							token,
							notificacao.protocolo,
						);
						if (apiResult && !apiResult.error) {
							data = apiResult;
						}
					}
				}

				const incidenteRaw =
					data.classificacao || classificacao?.classificacao || '';
				const subRaw =
					data.sub_classificacao ||
					classificacao?.sub_classificacao ||
					'';
				const prazoRaw =
					data.prazo_investigacao ||
					classificacao?.prazo_investigacao ||
					'';

				if (!isMounted) return;

				setIsNeverEvents(incidenteRaw === 'NEVER_EVENTS');
				setIncidenteLabel(formatIncidente(incidenteRaw));
				setPrazoLabel(formatDateBr(prazoRaw));

				let neverEventNome;
				if (subRaw && Cookies.get('user')) {
					const { token } = JSON.parse(Cookies.get('user'));
					if (token) {
						const choices = await requestNeverevents(token);
						if (
							choices &&
							!choices.error &&
							choices.sub_classificacao
						) {
							const choicesMap = choices.sub_classificacao;
							neverEventNome = choicesMap[subRaw]?.nome || subRaw;
						}
					}
				}

				if (isMounted) setNeverEventLabel(neverEventNome);
			} catch (error) {
				console.error(
					'Erro ao carregar classificação para PDF:',
					error,
				);
			} finally {
				if (isMounted) onReadyRef.current?.();
			}
		};

		loadClassificacao();
		return () => {
			isMounted = false;
		};
	}, [classificacao, notificacao?.protocolo]);
	return (
		<div
			ref={ref}
			className='p-[16px] w-[800px] bg-white font-inter break-inside-avoid page-break-inside-avoid'>
			{/* Header */}
			{/* <div className='bg-[#F0F4F8] flex rounded-sm w-full content-center min-h-[120px] p-[16px] gap-[20px] justify-between lg:flex-row flex-col'>
				<div className='content-center items-center mx-auto'>
					<img
						className='w-[200px] h-auto'
						src={logo}
						alt='logo'
					/>
				</div>
				<p className='text-[24px] font-bold text-[#13335A] content-center max-w-[600px] text-center'>
					NOTIFICAÇÃO DE INCIDENTES E NÃO CONFORMIDADES
				</p>
			</div> */}
			<div className='flex flex-col gap-[16px] mt-[16px]'>
				{/* CLASSIFICAÇÃO DO INCIDENTE */}
				<div
					data-pdf-block='true'
					style={avoidPageBreakStyle}
					className='flex flex-col border-[1px] border-[#E3E3E3] rounded-md'>
					<p className='text-[#004A80] bg-[#F4F4F4] rounded-t-md text-[18px] text-center font-semibold border-[#E3E3E3] border-b-[1px] py-1 pb-6'>
						CLASSIFICAÇÃO DO INCIDENTE
					</p>

					<div className='p-3 w-full'>
						<p className='text-[#004A80] font-medium'>Incidente</p>
						<div className='h-[40px] flex items-center px-2'>
							{incidenteLabel || 'não informado'}
						</div>
					</div>
					{isNeverEvents && (
						<div className='h-[1px] w-[97.5%] mx-auto bg-[#E3E3E3]'></div>
					)}
					{isNeverEvents && (
						<div className='p-3 w-full'>
							<p className='text-[#004A80] font-medium'>
								Never Event
							</p>
							<div className='h-[40px] flex items-center px-2'>
								{neverEventLabel || 'não informado'}
							</div>
						</div>
					)}
				</div>

				{/* ANÁLISE DO INCIDENTE */}
				<div
					data-pdf-block='true'
					style={avoidPageBreakStyle}
					className='flex flex-col border-[1px] border-[#E3E3E3] rounded-md'>
					<p className='text-[#004A80] bg-[#F4F4F4] rounded-t-md text-[18px] text-center font-semibold py-1 pb-6 border-[#E3E3E3] border-b-[1px]'>
						ANÁLISE DO INCIDENTE
						<span className='block text-[16px] font-normal'>
							Preenchido pelo Núcleo de Segurança do Paciente
						</span>
					</p>

					<div className='p-3 w-full flex flex-col gap-2'>
						<p className='text-[#004A80] font-medium'>
							Prazo máximo para a conclusão da investigação
						</p>
						<div className='h-[40px] flex items-center px-2'>
							{prazoLabel || 'não informado'}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});

export default ClassificacaoPDF;
